import React, { useContext, useEffect, useRef, useState } from "react";
// import { fetchContent, getBaseURL } from "../../services/api";
import shaka from "shaka-player/dist/shaka-player.ui.js";
import VideoPlayerUI from "./videoPlayerUI";
import {
  addContinueWatching,
  createDrmLicense,
  createDrmLicenseV2,
  getContinueResponse,
  getVideoUrlV2,
  getContentPlaybackInfo,
} from "../../services/services";
import { getBaseURL } from "../networkManager/networkHandler";
import { sendTestMatomoEvent } from "../../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../../AppContext";
import { handleVideoNavigationEvent, motamoPlayPauseEvent, sendLiveChannelEvent, sendWatchListEvent, mediaPlayBackMotamoEvent as matomoPlaybackEvent } from "../../Analytics/MatomoManager/matomoMedia";
import { logVideoErrorEvent } from "../../Analytics/MatomoManager/errorLog";
// globals moved into component refs to avoid leaks across mounts

const VideoPlayer = (props) => {
  const {
    selectedItem,
    CurrentItem,
    currentItemSeason,
    hasNextContent,
    nextAvailableContent,
    onSelect,
    videoSrc,
    type,
    availableBitrates,
    adConfig = null,
    backgroundImage,
    controlsColor = "#FFFFFF",
    controlBarHeight = "50px",
    progressBarColor = "#FF671F",
    itemData,
    onAdStart,
    onAdEnd,
    onPlay,
    onPause,
    onResume,
    onForward,
    onRewind,
    onError,
    onBack,
    isLive = false,
    DRMToken = null,
    mpdXMLInfo,
    DrmInformatin,
    GetVideoUrlData,
    itemDetails,
    VideoDataDrm,
  } = props;

  console.log("VideoDataDrm", itemData, itemDetails, "GetVideoUrlData", GetVideoUrlData, DrmInformatin, VideoDataDrm, CurrentItem);

  const videoRef = useRef(null);
  const seekTimeoutRef = useRef(null);
  const mediaIdRef = useRef(null);
  const currentVideoId = useRef(null);
  const adVideoRef = useRef(null);
  const adStartTimeRef = useRef(null);
  const isComponentMounted = useRef(true);
  const adElapsedTimeRef = useRef(0);
  const intervalRef = useRef(null);
  const lastContinueWatchingTime = useRef(0);
  const playerRef = useRef(null);
  const currentTimeRef = useRef(0);
  const watchedSecondsRef = useRef(0);
  const lastReportedTimeRef = useRef(0);
  // Threshold (seconds) to treat a jump/seek as non-watched time
  const WATCH_JUMP_THRESHOLD = 5;
  const [currentBitrate, setCurrentBitrate] = useState(0);
  const [focusedButton, setFocusedButton] = useState("playPause");
  // const [lastFocused, setLastFocused] = useState("playPause");
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isAdPlaying, setIsAdPlaying] = useState(false);
  const [controlsVisible, setControlsVisible] = useState(false);
  const [forceDisableControls, setForceDisableControls] = useState(false);
  const [lastUserActivity, setLastUserActivity] = useState(Date.now());
  const [showBgImage, setShowBgImage] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [showLanguage, setLanguageSettings] = useState(false);
  const [isAudio, setType] = useState(false);
  const [shouldloadVideo, shouldLoad] = useState(true);
  const [loading, showLoader] = useState(true);
  const [currentIndexLive, setcurrentIndexLive] = useState(0);
  const [incurrentTime, setinCurrentTime] = useState("00:00:00");
  const [totalTime, setTotalTime] = useState("00:00:00");
  const [hasPlayerLoadTimedOut, setHasPlayerLoadTimedOut] = useState(false);
  const [seekInProgress, setSeekInProgress] = useState(false);
  const [currentTimeSeek, setCurrentTimeSeek] = useState(0);
  const [isLiveContent, setIsLiveContent] = useState(isLive);
  const [showPlayerErrorUI, setShowPlayerErrorUI] = useState(false);
  const [showPlayPauseButtonUi, setShowPlayPauseButtonUi] = useState(false);
  const [duration_ad, setduration_ad] = useState(0);
  const [currentTime_ad, setcurrentTime_ad] = useState(0);
  const [isAdPlayingActive, setisAdPlayingActive] = useState(false);
  const [player, setPlayer] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentDrmInfo, setCurrentDrmInfo] = useState([]);
  const [playedVideos, setPlayedVideos] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true); // To track the first play
  const [Isnext, setIsnext] = useState(false);
  const [CurrentItemData, setCurrentItemData] = useState(null);
  const [lastTrackedVideoId, setLastTrackedVideoId] = useState(null);
  const [SkipAD, setSkipAD] = useState(false);
  const [SkipAdTime, setSkipAdTime] = useState(0);
  // const [preloadedImagesdata, setpreloadedImagesdata] = useState({});
  const [selectSpeed, setSelectSpeed] = useState(1);
  const [selectedQuality, setSelectedQuality] = useState();
  const [subtitle, setSubtitle] = useState();
  const [language, setLanguage] = useState();
  const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");
  const abortControllerRef = useRef(null);
  const accumulatedSeekRef = useRef(0);


  // Refs to replace former globals (avoid cross-mount leaks)
  const vdoElementRef = useRef(null);
  const intervalIdRef = useRef(null);
  const playbackTimeoutRef = useRef(null);
  const subtitleTextRef = useRef("");
  const languageTextRef = useRef("");
  const videoSettingsRef = useRef(false);
  const videoLanguageRef = useRef(false);
  const isDeletedRef = useRef(null);
  const clientAdsRef = useRef("server");

  const gender =
    userDetails?.gender === 1
      ? "Male"
      : userDetails?.gender === 2
      ? "Female"
      : "Not Available";

  const age = userDetails?.dob
    ? calculateAge(userDetails.dob)
    : "Not Available";

  const profile = JSON.parse(localStorage.getItem("myProfile"));

  const profileType =
    profile?.isKids === 0 || profile?.is_kid === 0
      ? "Adult"
      : profile?.isKids === 1 || profile?.is_kid === 1
      ? "Child"
      : "";

  function calculateAge(dobString) {
    if (!dobString) return null;
    const today = new Date();
    const dob = new Date(dobString);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // adjust if birthday hasn't happened yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }

  const { sourceContext, setSourceContext } = useContext(AppContext);

  // console.log("DrmInformatin",DrmInformatin)
  // let trickPlayArray = {};
  // let preloadedImages = {};

  // console.log("DrmInformatin", CurrentItemData);

  const userId = localStorage.getItem("profileId");
  const getCountry = localStorage.getItem("country");
  let headers = {
    iskid: "0",
    Langid: "1",
    "Content-Type": "application/json",
    country: getCountry,
    age: "12",
  };

  const handleWaitingState = (flag) => {
    setShowPlayPauseButtonUi(!flag);
    showLoader(flag);
  };

  useEffect(() => {
    console.log("itemDetailsGetVideoUrlData", isLive, isLiveContent, itemData, GetVideoUrlData, DrmInformatin, VideoDataDrm, currentItemSeason);
    // if (VideoDataDrm?.trick_play_url) {
    //   let media_duration = VideoDataDrm?.video_duration;
    //   let trickPlayData = VideoDataDrm?.trick_play_url;
    //   trickPlayArray = calculate_trickplay(trickPlayData, media_duration);
    // }
    if (!isLive || !isLiveContent) {
      if (itemDetails[0]?.skip_season == 0) {
        console.log(
          "itemDetailsGetVideoUrlData",
          itemDetails[0],
          GetVideoUrlData,
          DrmInformatin
        );
        handleNextAudio();
        // initVideo(DrmInformatin?.data);
      } else {
        console.log(
          "itemDetailsGetVideoUrlData...1234",
          GetVideoUrlData,
          DrmInformatin
        );
        setIsnext(true);
        if (DrmInformatin?.data) {
          initVideo(DrmInformatin?.data);
        } else {
          console.log("itemDetailsGetVideoUrlData...1234", GetVideoUrlData, DrmInformatin, VideoDataDrm);
          // Use GetVideoUrlData[0] if available, otherwise fallback to VideoDataDrm
          // Handle VideoDataDrm being an array or object
          const drmData = GetVideoUrlData?.[0] || (Array.isArray(VideoDataDrm) ? VideoDataDrm[0] : VideoDataDrm);
          console.log("Calling initVideo with:", drmData);
          initVideo(drmData);
        }
      }
    } else {
      if (itemData.file_url !== "") {
        console.log("itemDetailsGetVideoUrlData...", itemData);
        initVideo1(itemData);
      } else {
        console.log("itemDetailsGetVideoUrlData...", GetVideoUrlData);
        initVideo(GetVideoUrlData[0]);
      }
    }
    return () => {
      if (playerRef.current) {
        try {
          playerRef.current.destroy(); // Cleanup on unmount
        } catch (e) {}
        playerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    // Only call initVideo if currentDrmInfo has valid data (not empty array and has required properties)
    const isValidDrmInfo = currentDrmInfo && 
      !Array.isArray(currentDrmInfo) && 
      Object.keys(currentDrmInfo).length > 0 &&
      (currentDrmInfo.file_url || currentDrmInfo.token);
    
    if (isValidDrmInfo) {
      if (itemDetails[0]?.skip_season == 0) {
        initVideo(currentDrmInfo);
      }
    }
    return () => {
      if (playerRef.current) {
        try {
          playerRef.current.destroy(); // Cleanup on unmount
        } catch (e) {}
        playerRef.current = null;
      }
    };
  }, [currentDrmInfo]);


  // Reactive Effect for VideoDataDrm prop updates (Critical for Async Data like Search)
  useEffect(() => {
    if (VideoDataDrm && !isLiveContent && itemDetails[0]?.skip_season != 0) {
      console.log("VideoDataDrm prop updated, initializing video:", VideoDataDrm);
      // Handle array vs object case
      const dataToInit = Array.isArray(VideoDataDrm) ? VideoDataDrm[0] : VideoDataDrm;
      if (dataToInit && (dataToInit.file_url || dataToInit.token || dataToInit.url)) {
         initVideo(dataToInit);
      }
    }
  }, [VideoDataDrm]);

  // Final cleanup on unmount: ensure player and timers are destroyed
  useEffect(() => {
    return () => {
      // Destroy shaka player if present
      if (playerRef.current) {
        try {
          playerRef.current.destroy();
        } catch (e) {}
        playerRef.current = null;
      }

      // Clear any playback timeout
      if (playbackTimeoutRef.current) {
        clearTimeout(playbackTimeoutRef.current);
        playbackTimeoutRef.current = null;
      }

      // Clear any interval ref
      if (intervalRef.current) {
        try {
          clearInterval(intervalRef.current);
        } catch (e) {}
        intervalRef.current = null;
      }

      // Remove global listeners
      try {
        window.removeEventListener("keydown", handleKeyDown);
      } catch (e) {}

      // Pause and release video elements
      try {
        if (adVideoRef.current) {
          adVideoRef.current.pause();
          adVideoRef.current.removeAttribute("src");
        }
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.removeAttribute("src");
          try {
            videoRef.current.load();
          } catch (e) {}
        }
      } catch (e) {}
    };
  }, []);

  function formatSecondsToHMS(seconds) {
    console.log(seconds, "seconds1");
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  }


function generateUUID() {
  return crypto.randomUUID();
}

  const getMotamoEvent = async () => {
    const currentVideoId =
      CurrentItemData?.id ?? itemData?.id ?? itemData?.show_id;

    setLastTrackedVideoId(currentVideoId);
    console.log(
      CurrentItemData,
      itemData,
      currentVideoId,
      "getMotamoEventCall"
    );

    const mediaId = `${generateUUID()}${currentVideoId}`;
    mediaIdRef.current = mediaId;

    // Initial Play event

     await motamoPlayPauseEvent({
      eventActionStatus: "Play",
      itemDetails,
      itemData,
      CurrentItemData,
      videoRef,
      currentTime,
      sourceContext,
      });
    if (sourceContext === "Watchlist") {
      await sendWatchListEvent ({
        actionType: "Play",
        itemData,
        itemDetails,
      });
    }
  };

  const initVideo1 = async (videoData) => {
    console.log("videoData 147", videoData);
     if (!isComponentMounted.current) return;
    if (!videoData) {
      onBack && onBack();
      return;
    }

    if (videoData.is_live == 1) {
      setIsLiveContent(true);
    } else {
      setIsLiveContent(false);
    }

    const videoElement = videoRef.current;
    if (!videoElement) return;
    try {
      if (player) {
        await player.unload(); // Important: unload before destroy
        await player.destroy();
        setPlayer(null);
        playerRef.current = null;
      }
      if (!("is_drm_protected" in videoData) || videoData.is_live != 1) {
        console.log("live");
        let mediaSource = new MediaSource();
        videoElement.src = URL.createObjectURL(mediaSource);
        videoElement.pause();
        videoElement.src = ""; // Clear previous source
        videoElement.removeAttribute("src");
        videoElement.load(); // Force reload to reset MediaSource
        await new Promise((resolve) => {
          mediaSource.addEventListener(
            "sourceopen",
            () => {
              resolve();
            },
            { once: true }
          );

          // Timeout fallback
          setTimeout(resolve, 3000);
        });
      }
      try {
        if (
          !("is_drm_protected" in videoData) ||
          videoData.is_drm_protected === 1
        ) {
          if (videoElement.srcObject instanceof MediaSource) {
            if (videoElement.srcObject.readyState !== "open") {
              console.warn("MediaSource not open, recreating...");
              videoElement.src = "";
              await new Promise((resolve) => setTimeout(resolve, 300));
            }
          }
        }
         if (!isComponentMounted.current) return;
        const newPlayer = new shaka.Player(videoElement);
        const ui = new shaka.ui.Overlay(newPlayer, videoElement, videoElement);
        const controls = ui.getControls();
        const container = controls.getServerSideAdContainer();
        const netEngine = newPlayer.getNetworkingEngine();
        const adManager = newPlayer.getAdManager();
        adManager.initMediaTailor(container, netEngine, videoElement);
        setPlayer(newPlayer);
        playerRef.current = newPlayer;
        if (abortControllerRef.current) {
          abortControllerRef.current.abort(); // cancel any old pending chunk downloads
        }
        abortControllerRef.current = new AbortController();
        const controller = abortControllerRef.current;

        // Attach AbortController to networking engine
        newPlayer
          .getNetworkingEngine()
          .registerRequestFilter((type, request) => {
            request.signal = controller.signal; // <-- this is what stops Shaka downloading
          });

        newPlayer.configure({
            streaming: {
                  bufferingGoal: 30, // Larger buffer for slower devices
                  rebufferingGoal: 15,
                  retryParameters: {
                    maxAttempts: 8, // More retries
                    baseDelay: 2000, // Longer delays
                    timeout: 60000 // Longer timeout
                  }
                },
                abr: {
                  enabled: true,
                  defaultBandwidthEstimate: 500000, // Conservative estimate
                  restrictions: {
                    maxBandwidth: 2000000 // Limit for VIDA
                  }
                },
          // streaming: {
          //   retryParameters: {
          //     maxAttempts: 5,
          //     baseDelay: 1000,
          //     backoffFactor: 2,
          //     fuzzFactor: 0.5,
          //     timeout: 30000
          //   }
          // },
          preferredTextLanguage: null,
          textDisplayFactory: () =>
            new shaka.text.SimpleTextDisplayer(videoElement),
        });

        // newPlayer.configure({
        //   preferredTextLanguage: null,
        //   textDisplayFactory: () =>
        //     new shaka.text.SimpleTextDisplayer(videoElement),
        // });
        newPlayer.setTextTrackVisibility(false);

        console.log("videoData 187", videoData);

        if (!isComponentMounted.current) {
          await newPlayer.destroy();
          return;
        }

        // DRM License URL
        const URL = `${getBaseURL()}/V1/onRequestCreateVideoLicense`;
        let TokenPram =
          videoData.DASH?.identifier == "lionsgate"
            ? "X-VUDRM-TOKEN"
            : "pallycon-customdata-v2";
        if (videoData.DASH) {
          newPlayer.configure({
            drm: {
              servers: {
                "com.widevine.alpha":
                  videoData.DASH?.identifier == "lionsgate"
                    ? videoData.DASH?.licenceUrl
                    : URL,
              },
              advanced: {
                "com.microsoft.playready": {
                  distinctiveIdentifierRequired: false,
                  persistentStateRequired: false,
                  videoRobustness: "SW_SECURE_DECODE",
                },
              },
            },
                  streaming: {
                  bufferingGoal: 30, // Larger buffer for slower devices
                  rebufferingGoal: 15,
                  retryParameters: {
                    maxAttempts: 8, // More retries
                    baseDelay: 2000, // Longer delays
                    timeout: 60000 // Longer timeout
                  }
                },
                abr: {
                  enabled: true,
                  defaultBandwidthEstimate: 500000, // Conservative estimate
                  restrictions: {
                    maxBandwidth: 2000000 // Limit for VIDA
                  }
                },
                  streaming: {
                  bufferingGoal: 30, // Larger buffer for slower devices
                  rebufferingGoal: 15,
                  retryParameters: {
                    maxAttempts: 8, // More retries
                    baseDelay: 2000, // Longer delays
                    timeout: 60000 // Longer timeout
                  }
                },
                abr: {
                  enabled: true,
                  defaultBandwidthEstimate: 500000, // Conservative estimate
                  restrictions: {
                    maxBandwidth: 2000000 // Limit for VIDA
                  }
                },
              // streaming: {
              //   retryParameters: {
              //     maxAttempts: 5,
              //     baseDelay: 1000,
              //     backoffFactor: 2,
              //     fuzzFactor: 0.5,
              //     timeout: 30000
              //   }
              // },
              preferredTextLanguage: null,
              textDisplayFactory: () => new shaka.text.SimpleTextDisplayer(videoElement)
          });
          if (videoData?.DASH?.token) {
            console.log("lionsgate......", videoData?.DASH);
            newPlayer
              .getNetworkingEngine()
              .registerRequestFilter((type, request) => {
                if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                  request.headers[`${TokenPram}`] = videoData?.DASH?.token;
                }
              });
            newPlayer
              .getNetworkingEngine()
              .registerRequestFilter((type, request) => {
                if (
                  request.uris[0].includes("mercury.akamaized.net/cm/e.gif") ||
                  request.uris[0].includes("mercury.akamaized.net/cm/i.gif")
                ) {
                  request.method = "GET";
                }
                //console.log(type);
                // console.log(request);
              });
          }

          await newPlayer
            .load(videoData?.DASH.url)
            .then(() => {})
            .catch((error) => {
              console.error("Error loading video:", error);
            });
          videoElement
            .play()
            .catch((error) => console.error("Playback error:", error));
          if (
            itemData?.paused_at &&
            window.isStartOverSelectedButton !== true
          ) {
            videoElement.currentTime = itemData?.paused_at;
          }
          vdoElementRef.current = videoElement;
        } else {
          if (
            !("is_drm_protected" in videoData) ||
            videoData.is_drm_protected === 1
          ) {
            console.log("call,,,");
            newPlayer.configure({
              drm: {
                servers: {
                  "com.widevine.alpha": URL,
                },
                advanced: {
                  "com.widevine.alpha": {
                    videoRobustness: ["SW_SECURE_DECODE"],
                    audioRobustness: ["SW_SECURE_CRYPTO"],
                  },
                },
                advanced: {
                  "com.microsoft.playready": {
                    distinctiveIdentifierRequired: false,
                    persistentStateRequired: false,
                    videoRobustness: "SW_SECURE_DECODE",
                  },
                },
              },
                // streaming: {
                //   retryParameters: {
                //     maxAttempts: 5,
                //     baseDelay: 1000,
                //     backoffFactor: 2,
                //     fuzzFactor: 0.5,
                //     timeout: 30000
                //   }
                // },
                preferredTextLanguage: null,
                textDisplayFactory: () => new shaka.text.SimpleTextDisplayer(videoElement)
            });
            newPlayer
              .getNetworkingEngine()
              .registerRequestFilter((type, request) => {
                if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                  request.headers["pallycon-customdata-v2"] = videoData?.token;
                }
              });
          }

          // var params = {
          //   adsParams: {},
          // };
          console.log("videoData 190", videoData);

          if (videoData.ad_enable === "1") {
            // Prepare ad parameters
            const params = {
              adsParams: {},
            };

            if (itemData.player_params.includes("os")) {
              params.adsParams.os = "4";
            }

            if (itemData.player_params.includes("ai")) {
              params.adsParams.ai = "wavespb.com";
            }

            if (itemData.player_params.includes("trq")) {
              const milliseconds = Date.now();
              params.adsParams.trq = milliseconds.toString();
            }

            if (itemData.player_params.includes("dt")) {
              params.adsParams.dt = "4";
            }

            if (itemData.player_params.includes("vmi")) {
              params.adsParams.vmi = "web";
            }

            if (itemData.player_params.includes("asi")) {
              params.adsParams.asi = "web";
            }

            if (itemData.player_params.includes("prerollasi")) {
              params.adsParams.prerollasi = "web";
            }

            if (itemData.player_params.includes("gn")) {
              params.adsParams.gn = "male";
            }

            if (itemData.player_params.includes("ag")) {
              params.adsParams.ag = "12";
            }

            if (itemData.player_params.includes("ifa")) {
              params.adsParams.ifa = "";
            }

            if (itemData.player_params.includes("vid_d")) {
              params.adsParams.vid_d =
                itemData.video_duration?.toString() || "0";
            }

            if (itemData.player_params.includes("cvl")) {
              params.adsParams.cvl = itemData.video_duration?.toString() || "0";
            }

            if (itemData.player_params.includes("contentpartner")) {
              params.adsParams.contentpartner =
                itemData.content_partner_key || "";
            }

            if (itemData.player_params.includes("ctid")) {
              params.adsParams.ctid = itemData.media_id
                ? itemData.media_id.toString()
                : itemData.video_id?.toString() || "";
            }

            if (itemData.player_params.includes("ctype")) {
              params.adsParams.ctype = "LIVE";
            }

            if (itemData.player_params.includes("chnm")) {
              params.adsParams.chnm = itemData.title || "";
            }

            if (itemData.player_params.includes("gnr")) {
              params.adsParams.gnr = itemData.genres?.toString() || "";
            }

            if (itemData.player_params.includes("iskp")) {
              params.adsParams.iskp = "";
            }

            if (itemData.player_params.includes("lang")) {
              params.adsParams.lang = itemData.language_title || "";
            }

            let uri = null;
            let videoUrl = videoData?.file_url;
            console.log("getvideourl....", videoUrl, videoData);
            try {
              uri = await adManager.requestMediaTailorStream(videoUrl, params);
            } catch (error) {
              console.log("error 275", error);
              uri = videoData?.file_url;
            }
            console.log("uri", uri);
            await newPlayer
              .load(uri)
              .then(() => {})
              .catch((error) => {
                console.error("Error loading video:", error);
              });

            adManager.addEventListener(shaka.ads.Utils.AD_STARTED, (e) => {
              setisAdPlayingActive(true);
              adStartTimeRef.current = Date.now();
              adElapsedTimeRef.current = 0;
              setcurrentTime_ad(0);
              if (e.ad.isSkippable()) {
                setSkipAD(true);
                setSkipAdTime(convertTimeStringToSeconds(e.ad.h.skipOffset));
              } else {
                setSkipAD(false);
              }
              setduration_ad(e.ad.getDuration());
            });

            adManager.addEventListener(shaka.ads.Utils.AD_STOPPED, (e) => {
              setisAdPlayingActive(false);
              adStartTimeRef.current = null;
              adElapsedTimeRef.current = 0;
              setSkipAD(false);
              setSkipAdTime(0);
              setcurrentTime_ad(0);
              setduration_ad(0);
            });
          } else if (videoData.ad_enable === "0") {
            await newPlayer
              .load(videoData.file_url)
              .then(() => {
                checkMediaType();
              })
              .catch((error) => {
                console.error("Error loading video:", error);
              });
          } else {
            // await player.load(itemData.file_url);
            console.log("No ads enabled for this video.");
            await newPlayer
              .load(VideoDataDrm?.file_url)
              .then(() => {
                checkMediaType();
              })
              .catch((error) => {
                console.error("Error loading video:", error);
              });
          }
          // else {
          //   console.log("videoData.file_url", videoData);
          //   await newPlayer
          //     .load(videoData?.file_url)
          //     // .load(DrmInformatin?.data?.file_url)
          //     .then(() => { })
          //     .catch((error) => {
          //       console.error("Error loading video:", error);
          //     });
          // }
          // }
          videoElement
            .play()
            .catch((error) => console.error("Playback error:", error));
          if (
            itemData?.paused_at &&
            window.isStartOverSelectedButton !== true
          ) {
            videoElement.currentTime = itemData?.paused_at;
          }
        }
        vdoElementRef.current = videoElement;

        getMotamoEvent();
      } catch (error) {
        console.error("Error loading video:", error);
        logVideoErrorEvent(currentTime, itemDetails, itemData, error);
      }
    } catch (error) {
      console.error("Error loading video:", error);
      videoElement.load(); // Force reload to reset MediaSource
      logVideoErrorEvent(currentTime, itemDetails, itemData, error);
    }
  };

  const initVideo = async (videoData) => {
    console.log("videoData 147", videoData);
    if (!isComponentMounted.current) return;
    if (!videoData) {
      onBack && onBack();
      return;
    }

    if (videoData.is_live == 1) {
      setIsLiveContent(true);
    } else {
      setIsLiveContent(false);
    }

    const videoElement = videoRef.current;
    if (!videoElement) return;
    try {
      if (player) {
        await player.unload(); // Important: unload before destroy
        await player.destroy();
        setPlayer(null);
      }
      if (!("is_drm_protected" in videoData) || videoData.is_live != 1) {
        console.log("live");
        let mediaSource = new MediaSource();
        videoElement.src = URL.createObjectURL(mediaSource);
        videoElement.pause();
        videoElement.src = ""; // Clear previous source
        videoElement.removeAttribute("src");
        videoElement.load(); // Force reload to reset MediaSource
        await new Promise((resolve) => {
          mediaSource.addEventListener(
            "sourceopen",
            () => {
              resolve();
            },
            { once: true }
          );

          // Timeout fallback
          setTimeout(resolve, 2000);
        });
      }
      try {
        if (
          !("is_drm_protected" in videoData) ||
          videoData.is_drm_protected === 1
        ) {
          if (videoElement.srcObject instanceof MediaSource) {
            if (videoElement.srcObject.readyState !== "open") {
              console.warn("MediaSource not open, recreating...");
              videoElement.src = "";
              await new Promise((resolve) => setTimeout(resolve, 300));
            }
          }
        }
        if (!isComponentMounted.current) return;
        const newPlayer = new shaka.Player(videoElement);
        const ui = new shaka.ui.Overlay(newPlayer, videoElement, videoElement);
        const controls = ui.getControls();
        const container = controls.getServerSideAdContainer();
        const netEngine = newPlayer.getNetworkingEngine();
        const adManager = newPlayer.getAdManager();
        adManager.initMediaTailor(container, netEngine, videoElement);
        setPlayer(newPlayer);
        playerRef.current = newPlayer;

        newPlayer.configure({
          preferredTextLanguage: null,
          textDisplayFactory: () =>
            new shaka.text.SimpleTextDisplayer(videoElement),
        });
        newPlayer.setTextTrackVisibility(false);

        console.log("videoData 187", videoData);

        if (!isComponentMounted.current) {
          await newPlayer.destroy();
          return;
        }

        // DRM License URL
        const URL = `${getBaseURL()}/V1/onRequestCreateVideoLicense`;
        let TokenPram =
          videoData.DASH?.identifier == "lionsgate"
            ? "X-VUDRM-TOKEN"
            : "pallycon-customdata-v2";
        if (videoData.DASH) {
          newPlayer.configure({
            drm: {
              servers: {
                "com.widevine.alpha":
                  videoData.DASH?.identifier == "lionsgate"
                    ? videoData.DASH?.licenceUrl
                    : URL,
              },
              advanced: {
                "com.microsoft.playready": {
                  distinctiveIdentifierRequired: false,
                  persistentStateRequired: false,
                  videoRobustness: "SW_SECURE_DECODE",
                },
              },
            },
          });
          if (videoData?.DASH?.token) {
            console.log("lionsgate......", videoData?.DASH);
            newPlayer
              .getNetworkingEngine()
              .registerRequestFilter((type, request) => {
                if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                  request.headers[`${TokenPram}`] = videoData?.DASH?.token;
                }
              });
            newPlayer
              .getNetworkingEngine()
              .registerRequestFilter((type, request) => {
                if (
                  request.uris[0].includes("mercury.akamaized.net/cm/e.gif") ||
                  request.uris[0].includes("mercury.akamaized.net/cm/i.gif")
                ) {
                  request.method = "GET";
                }
                //console.log(type);
                // console.log(request);
              });
          }

          await newPlayer
            .load(videoData?.DASH.url)
            .then(() => {})
            .catch((error) => {
              console.error("Error loading video:", error);
              logVideoErrorEvent(currentTime, itemDetails, itemData, error);

            });
          videoElement
            .play()
            .catch((error) => {console.error("Playback error:", error)
            logVideoErrorEvent(currentTime, itemDetails, itemData, error);

            });

          if (
            itemData?.paused_at &&
            window.isStartOverSelectedButton !== true
          ) {
            videoElement.currentTime = itemData?.paused_at;
          }
          vdoElementRef.current = videoElement;
        } else {
          if (
            !("is_drm_protected" in videoData) ||
            videoData.is_drm_protected === 1
          ) {
            console.log("call,,,");
            newPlayer.configure({
              drm: {
                servers: {
                  "com.widevine.alpha": URL,
                },
                advanced: {
                  "com.widevine.alpha": {
                    videoRobustness: ["SW_SECURE_DECODE"],
                    audioRobustness: ["SW_SECURE_CRYPTO"],
                  },
                },
                advanced: {
                  "com.microsoft.playready": {
                    distinctiveIdentifierRequired: false,
                    persistentStateRequired: false,
                    videoRobustness: "SW_SECURE_DECODE",
                  },
                },
              },
            });
            newPlayer
              .getNetworkingEngine()
              .registerRequestFilter((type, request) => {
                if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
                  request.headers["pallycon-customdata-v2"] = videoData?.token;
                }
              });
          }

          var params = {
            adsParams: {},
          };
          const mdParams = {};
          console.log("videoData 190", videoData);

          // if (videoData?.custom_params && videoData?.custom_params.length > 0) {
          //   const customParams = videoData.custom_params;

          //   if (customParams.includes("gn")) {
          //     customParams.md_gn = gender;
          //   }

          //   if (customParams.includes("ag")) {
          //     customParams.md_ag = age;
          //   }

          //   if (customParams.includes("ctid")) {
          //     customParams.md_ctid = `${itemDetails[0]?.id}`;
          //   }

          //   if (customParams.includes("ctype")) {
          //     customParams.md_ctype = "VOD";
          //   }

          //   if (customParams.includes("iskp")) {
          //     customParams.md_iskp = "";
          //   }

          //   if (customParams.includes("lang")) {
          //     customParams.md_lang = `${itemDetails[0]?.language_title}`;
          //   }

          //   console.log("custom_params....", customParams);
          // }

          if (videoData?.custom_params && videoData?.custom_params.length > 0) {
            const customParams = videoData.custom_params;
            // const mdParams = {}; // <-- new object only for md_ keys

            if (customParams.includes("gn")) {
              mdParams.md_gn = gender;
            }

            if (customParams.includes("ag")) {
              mdParams.md_ag = `${age}`;
            }

            if (customParams.includes("ctid")) {
              mdParams.md_ctid = `${itemDetails[0]?.id}`;
            }

            if (customParams.includes("ctype")) {
              mdParams.md_ctype = "VOD";
            }

            if (customParams.includes("iskp")) {
              mdParams.md_iskp = "";
            }

            if (customParams.includes("lang")) {
              mdParams.md_lang = `${itemDetails[0]?.language_title}`;
            }

            console.log("custom_params....", mdParams); // ✅ only md_* keys
          }

          if (videoData && videoData?.player_params) {
            console.log("call 247");
            const playerParams = videoData?.player_params;
            if (playerParams.includes("os")) {
              params.adsParams.os = "4";
            }
            if (playerParams.includes("ai")) {
              params.adsParams.ai = "wavespb.com";
            }
            if (playerParams.includes("trq")) {
              params.adsParams.trq = `${Date.now().toString()}`;
            }
            if (playerParams.includes("dt")) {
              params.adsParams.dt = "4";
            }
            if (playerParams.includes("ag")) {
              params.adsParams.ag = `${age}`;
            }
            if (playerParams.includes("gn")) {
              params.adsParams.gn = gender;
            }
            if (playerParams.includes("vmi")) {
              params.adsParams.vmi = "web";
            }
            if (playerParams.includes("ifa")) {
              params.adsParams.ifa = "";
            }
            if (playerParams.includes("cvl")) {
              params.adsParams.cvl = `${itemDetails[0]?.video_time}`;
            }
            if (playerParams.includes("ctid")) {
              params.adsParams.ctid = `${itemDetails[0]?.id}`;
            }
            if (playerParams.includes("ctype")) {
              params.adsParams.ctype = "VOD";
            }
            if (playerParams.includes("gnr")) {
              params.adsParams.gnr = `${itemDetails[0]?.genres}`;
            }
            if (playerParams.includes("prerollasi")) {
              params.adsParams.prerollasi = "web";
            }
            if (playerParams.includes("collection")) {
              params.adsParams.collection = `${itemDetails[0]?.collection_id}`;
            }
            //  params.adsParams.cust_param=uriEncodeURIComponent(`ctid=${itemDetails[0]?.id}|ctype=VOD|cvl=${itemDetails[0]?.video_time}|collection=${itemDetails[0]?.collection_id}|gnr=${itemDetails[0]?.genres}`);

            // 🔑 Convert mdParams to query string
            //   if(videoData?.custom_params && videoData?.custom_params.length > 0){
            //   let queryString = Object.entries(mdParams)
            //   .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            //   .join("&");

            // // replace =, &, , with encoded versions
            // queryString = queryString
            //   .replace(/=/g, "%3D")
            //   .replace(/&/g, "%26")
            //   .replace(/,/g, "%2C");

            // // assign
            // // params.adsParams.cust_params = queryString;
            //   playerParams.cust_params = queryString;
            //   }

            if (
              videoData?.custom_params &&
              videoData?.custom_params.length > 0
            ) {
              let queryString = Object.entries(mdParams)
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join("&");

              // Replace special characters with encoded versions
              queryString = queryString
                .replace(/=/g, "%3D")
                .replace(/&/g, "%26")
                .replace(/,/g, "%2C");

              console.log(
                "Original playerParams:",
                JSON.stringify(playerParams, null, 2)
              );

              // Find the object containing cust_params
              const custParamsObj = playerParams.find(
                (item) =>
                  item &&
                  typeof item === "object" &&
                  item.hasOwnProperty("cust_params")
              );

              console.log("Found custParamsObj:", custParamsObj);

              if (custParamsObj) {
                console.log(
                  "Before appending - cust_params:",
                  custParamsObj.cust_params
                );
                // Append to existing cust_params
                custParamsObj.cust_params += "%26" + queryString;
                console.log(
                  "After appending - cust_params:",
                  custParamsObj.cust_params
                );
              } else {
                console.log(
                  "No existing cust_params found, creating new object"
                );
                playerParams.push({ cust_params: queryString });
              }

              console.log(
                "Original playerParams:",
                JSON.stringify(playerParams, null, 2)
              );
            }

            let uri = null;
            let videoUrl = videoData?.file_url;
            console.log("getvideourl....", videoUrl, videoData, itemDetails[0]);
            try {
              uri = await adManager.requestMediaTailorStream(videoUrl, params);
            } catch (error) {
              console.log("error 275", error);
              uri = videoData?.file_url;
            }
            console.log("uri", uri);
            await newPlayer
              .load(uri)
              .then(() => {})
              .catch((error) => {
                console.error("Error loading video:", error);
              });

            adManager.addEventListener(shaka.ads.Utils.AD_STARTED, (e) => {
              setisAdPlayingActive(true);
              adStartTimeRef.current = Date.now();
              adElapsedTimeRef.current = 0;
              setcurrentTime_ad(0);
              if (e.ad.isSkippable()) {
                setSkipAD(true);
                setSkipAdTime(convertTimeStringToSeconds(e.ad.h.skipOffset));
              } else {
                setSkipAD(false);
              }
              setduration_ad(e.ad.getDuration());
            });

            adManager.addEventListener(shaka.ads.Utils.AD_STOPPED, (e) => {
              setisAdPlayingActive(false);
              adStartTimeRef.current = null;
              adElapsedTimeRef.current = 0;
              setSkipAD(false);
              setSkipAdTime(0);
              setcurrentTime_ad(0);
              setduration_ad(0);
            });
          } else {
            console.log("videoData.file_url", videoData);
            await newPlayer
              .load(videoData?.file_url)
              // .load(DrmInformatin?.data?.file_url)
              .then(() => {})
              .catch((error) => {
                logVideoErrorEvent(currentTime, itemDetails, itemData, error);
                console.error("Error loading video:", error);
              });
          }
        }
        videoElement
          .play()
          .catch((error) => {console.error("Playback error:", error)
          logVideoErrorEvent(currentTime, itemDetails, itemData, error);
          });
        if (itemData?.paused_at && window.isStartOverSelectedButton !== true) {
          videoElement.currentTime = itemData?.paused_at;
        }
        // Reset watched-time tracking for this new media
        watchedSecondsRef.current = 0;
        lastReportedTimeRef.current = videoElement.currentTime || 0;
        vdoElementRef.current = videoElement;

        getMotamoEvent();
      } catch (error) {
        console.error("Error loading video:", error);
        logVideoErrorEvent(currentTime, itemDetails, itemData, error);
      }
    } catch (error) {
      console.error("Error loading video:", error);
      videoElement.load(); // Force reload to reset MediaSource
      logVideoErrorEvent(currentTime, itemDetails, itemData, error);
    }
    setTimeout(() => {
      console.log("Anupam ",videoElement.currentTime , videoElement.paused)
      if (videoElement.currentTime===0){
        videoElement.currentTime = 0 
      }    
    }, 2000);
  };

  // console.log("videoplayer.....", itemData);


  const commitSeek = (newTime) => {
    if (vdoElementRef.current) {
      vdoElementRef.current.currentTime = newTime;
      setCurrentTime(newTime);

      // Prevent the next timeupdate from treating this jump as watched playback
      // Handle your Analytics/Matomo events here based on the final seek time
      // handleMotamoForwardEvent() or handleMotamoRewindEvent()
      lastReportedTimeRef.current = newTime;
       const totalDelta = accumulatedSeekRef.current;
       if(totalDelta === 10){
     handleVideoNavigationEvent({
     type: "forward",
     delta: 10,
     itemDetails,
     itemData,
     CurrentItemData,
     currentTime,
});
    } else if(totalDelta > 10){
   handleVideoNavigationEvent({
  type: "seek",
  newTime: parseInt(newTime),
  itemDetails,
  itemData,
  CurrentItemData,
  currentTime,
});
  } else if(totalDelta === -10 )
    handleVideoNavigationEvent({
    type: "rewind",
    delta: -10,
    itemDetails,
    itemData,
    CurrentItemData,
    currentTime: newTime,
    });
  accumulatedSeekRef.current = 0;


    }

    // Slight delay before turning off the UI "seeking" state to prevent flickering
    setTimeout(() => {
      setSeekInProgress(false);
    }, 100);
  }; 

  // const AddToContinueWatching = async (is_deleted) => {
  //   console.log("AddToContinueWatching called with is_deleted:", is_deleted);
  //   try {
  //     let user_details = JSON.parse(localStorage.getItem("user_details"));
  //     let headers = {
  //       Langid: "1",
  //       profileid: user_details.user_profiles[0].profile_id,
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
  //     };
  //     let postParam =
  //     // [
  //     {
  //       show_id: itemData.id,
  //       video_id: itemData.video_id,
  //       title: itemData.title,
  //       a_lang: languageText,
  //       s_lang: subtitleText,
  //       paused_at: currentTime,
  //       video_duration: duration,
  //       // s_No: itemData.s_No,
  //       // ep_No: itemData.ep_No,
  //       is_deleted: is_deleted,
  //     };
  //     // },
  //     // ];
  //     // const [watchlistAddDelResponse] = await Promise.all([
  //     //   fetchContent(
  //     //     "/V1/continueWatching",
  //     //     "POST",
  //     //     headers,
  //     //     JSON.stringify(postParam)
  //     //   ),
  //     // ]);

  //     const watchlistAddDelResponse = await addContinueWatching(postParam,headers);
  //     console.log("postParam...", postParam, language, subtitle);
  //     // const watchlistAddDelResponse = await getContinueResponse(postParam);

  //     // continue_watching();
  //   } catch (error) {
  //     console.error();
  //   }
  // };

  const AddToContinueWatching = async (is_deleted) => {
  console.log("AddToContinueWatching called with is_deleted:",  itemData, itemDetails);
  if (itemData?.is_live === 1 || itemData.still_live === 1) {
    console.log("Live content detected, skipping continue watching update.");
    return; 
  }
  try {
    let user_details = JSON.parse(localStorage.getItem("user_details"));
 
    let headers = {
      Langid: "1",
      profileid: user_details.user_profiles[0].profile_id,
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
    };
 
    // >>> FIX INSERTED HERE <<<
    let safeDuration =
      playerRef.current?.getDuration?.() ||
      playerRef.current?.getMediaElement?.()?.duration ||
      videoRef.current?.duration ||
      duration ||
      0;
    let showId = itemData.id !== undefined ? itemData.id : itemData.show_id;
    let postParam = {
      show_id:showId,
      video_id: itemData.video_id,
      title: itemData.title,
      a_lang: languageTextRef.current,
      s_lang: subtitleTextRef.current,
      paused_at: currentTime,
      video_duration: safeDuration,
      is_deleted: is_deleted,
      // s_No:itemDetails[0]?.season[0]?.number,
      // ep_No:itemDetails[0]?.season[0]?.tracks
    };
 
    const watchlistAddDelResponse = await addContinueWatching(postParam, headers);
    console.log("ContinueWatching Payload:", postParam, watchlistAddDelResponse, itemData,itemDetails);
  } catch (error) {
    console.error(error);
  }
};
  const continue_watching = async () => {
    let user_details = JSON.parse(localStorage.getItem("user_details"));
    try {
      let headers = {
        Langid: "1",
        platform: "0",
        lastupdated: "0000000000",
        profileid: user_details.user_profiles[0].profile_id,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      };

      // const [addcontinuewatch] = await Promise.all([
      //   fetchContent(
      //     "/V1/getContinueWatching/lastupdated/0000000000",
      //     "GET",
      //     headers
      //   ),
      // ]);

      // const addcontinuewatch = await getContinueWatching();
      const addcontinuewatch = await getContinueResponse();
    } catch (error) {
      console.error();
    }
  };

  const handleNextAudio = async (isUserClick = false) => {
    console.log("itemDetailsGetVideoUrlData...", nextAvailableContent);
    isDeletedRef.current = 1;
    AddToContinueWatching(1); //initVideo(DrmInformatin?.data);
    if (itemDetails[0]?.skip_season == 0) {
      console.log("itemDetailsGetVideoUrlData...", nextAvailableContent);
      if (nextAvailableContent) {
        console.log("itemDetailsGetVideoUrlData...", nextAvailableContent);
        let seasons = itemDetails[0]?.season || [];
        let filteredSeasons = seasons.filter((season) =>
          season.videos.some(
            (video) => video.number === nextAvailableContent?.number
          )
        );

        console.log("itemDetailsGetVideoUrlData..", filteredSeasons);

        if (!filteredSeasons.length) return;

        let indexx = filteredSeasons[0].videos.findIndex(
          (video) => video.id === nextAvailableContent.id
        );

        if (indexx < 0) return; // Prevent invalid index access

        let startIndex = isFirstLoad ? indexx - 1 : indexx; // On first play, start with indexx - 1
        if (startIndex < 0) startIndex = 0; // Ensure startIndex does not go below 0

        // Store previous videos from 1 to current index
        let previousVideos = filteredSeasons[0].videos.slice(0, indexx + 1);
        setPlayedVideos(previousVideos);

        setIsFirstLoad(false); // Mark first load as completed
        setCurrentIndex(indexx > currentIndex ? indexx : currentIndex + 1); // Play first time with
        // startIndex
        console.log("itemDetailsGetVideoUrlData...", currentIndex);
        await playVideoByIndex(
          filteredSeasons[0].videos,
          isFirstLoad ? startIndex : startIndex,
          isUserClick
        );
      } else {
        console.log("itemDetailsGetVideoUrlData...", nextAvailableContent);
        let foundSeasonIndex = -1;
        let foundVideoIndex = -1;
        const seasonss = itemDetails[0]?.season || [];
        seasonss.some((season, seasonIndex) => {
          const videoIndex = season.videos.findIndex(
            (video) => video.id === currentItemSeason
          );
          if (videoIndex !== -1) {
            console.log("abcd.....5555555.........", itemDetails);
            foundSeasonIndex = seasonIndex;
            foundVideoIndex = videoIndex;
            return true; // Breaks the loop once found
          }
          return false;
        });
        if (currentItemSeason) {
          console.log("abcd.....6666666666.........", itemDetails);
          let seasons = itemDetails[0]?.season[foundSeasonIndex].videos || [];
          setCurrentIndex(currentIndex + 1);
          await playVideoByIndex(seasons, foundVideoIndex, isUserClick);
        } else {
          console.log("abcd.....77777777777.........", itemDetails);
          let seasons = itemDetails[0]?.season[0].videos || [];
          setCurrentIndex(currentIndex + 1);
          await playVideoByIndex(seasons, currentIndex, isUserClick);
        }
      }
    } else {
      console.log("itemDetailsGetVideoUrlData", DrmInformatin);
      initVideo(DrmInformatin.data);
    }
  };

  const playVideoByIndex = async (videos, index, isUserClick = false) => {
    const filteredVideos = videos.filter((video) => video.is_trailer !== 1);
    if (index >= filteredVideos.length) return;
    const nextVideoId = filteredVideos[isFirstLoad ? index : currentIndex]?.id;
    const nextVideoIndex = filteredVideos.findIndex(
      (video) => video.id === nextVideoId
    );
    if (nextVideoIndex === filteredVideos.length - 1) {
      console.log("playVideoByIndex...111..", videos, index);
      setIsnext(true);
    } else {
      console.log("playVideoByIndex....2222...", videos, index);
      setIsnext(false);
    }

    const isSubscribe = window.IS_DISPLAY == "0" ? "true" : "false";

    if (nextVideoId) {
      try {
        // Send next track event - only when user explicitly clicks next episode button
        const nextTrackTitle =
          filteredVideos[isFirstLoad ? index : currentIndex]?.title ||
          "Unknown";
        if (isUserClick) {
          await sendTestMatomoEvent({
            eventCategory: "Video",
            eventAction: "Next",
            eventName: `${nextVideoId}/${itemData?.title}/${nextTrackTitle}(VOD)`,
          });
        }

        await new Promise((resolve) => setTimeout(resolve, 300));
        
        // 1. Check if partner content
        const ownedBy = itemDetails[0]?.owned_by ?? itemData?.owned_by;
        const isPartnerContent = ownedBy === undefined || ownedBy > 0;
        
        let videoUrlResponse = { data: null };
        
        // 2. Try Partner API first if likely partner content
        if (isPartnerContent) {
          try {
            const currentVideo = filteredVideos[isFirstLoad ? index : currentIndex];
            const contentId = currentVideo?.contentId || itemData?.contentId;
            
            if (contentId) {
              const publisherId = ownedBy !== undefined ? ownedBy : 17;
              const body = { contentId: contentId };
              const headers = { publisher_id: `${publisherId}`, event: "false", tag: "0" };
              console.log("Attempting Partner API with:", body);
              videoUrlResponse = await getContentPlaybackInfo(publisherId, body, headers);
            }
          } catch (e) {
            console.warn("Partner API failed, falling back to standard API", e);
          }
        }

        // 3. Fallback: If no data from Partner API (or not partner), try standard API
        if (!videoUrlResponse?.data) {
          console.log("Using standard getVideoUrlV2 (fallback or primary)");
          try {
            videoUrlResponse = await getVideoUrlV2(nextVideoId, userId, isSubscribe);
          } catch (e) {
            console.error("Standard getVideoUrlV2 failed", e);
          }
        }

        if (videoUrlResponse?.data) {
          setCurrentItemData(videoUrlResponse.data);
          const postBody = {
            vdc_id: videoUrlResponse.data.vdc_id,
            media_id: videoUrlResponse.data.id,
          };

          if (videoUrlResponse?.data?.is_drm_protected == 1) {
            const isSubscribe = window.IS_DISPLAY == "0" ? "true" : "false";

            // drmInfo = await createDrmLicenseV2(isSubscribe, postBody);
            const drmDetails = await createDrmLicenseV2(isSubscribe, postBody);
            // const drmDetails = await createDrmLicense(postBody);
            if (drmDetails?.data) {
              setCurrentDrmInfo(drmDetails.data);
              initVideo(drmDetails?.data);
            }
          } else {
            setCurrentDrmInfo(videoUrlResponse.data);
            initVideo(videoUrlResponse.data);
          }
          // const drmDetails = await fetchContent(
          //   "/V1/createDrmLicense",
          //   "POST",
          //   headers,
          //   JSON.stringify(postBody)
          // );

          // if (drmDetails?.data) {
          //   console.log("drmDetails...", drmDetails.data);
          //   setCurrentDrmInfo(drmDetails.data);
          //   initVideo(drmDetails.data); // Load new video with correct token
          // }
        }
      } catch (error) {
        console.error("Error fetching DRM details:", error);
      }
    }
  };

  // ...existing code...

  // ...existing code...

  // useEffect(() => {
  //   clearTimeout(playerPlaybackTimeout);
  //   playerPlaybackTimeout = null;
  //   playerPlaybackTimeout = setTimeout(() => {
  //     showLoader(false);
  //     setForceDisableControls(true);
  //     setHasPlayerLoadTimedOut(true);
  //     setShowPlayerErrorUI(true);
  //     player && player.destroy();
  //   }, 15 * 1000);
  // }, []);

  // Working Code Below
  // Centralized playback progress updater — handles display updates, watched-seconds accumulation, duration and pooling logic
  const updatePlaybackProgress = (current, { isAd = false } = {}) => {
    if (current == null) return;

    // Keep UI in sync
    currentTimeRef.current = current;
    setinCurrentTime(formatTime(current));

    // Track ad time separately
    if (isAd) {
      setcurrentTime_ad(current);
    } else {
      setCurrentTime(current);
    }

    // Duration & live detection
    const maxDuration = 24 * 60 * 60; // 24 hours in seconds
    let videoDuration = isAd ? adVideoRef.current?.duration : videoRef.current?.duration;
    if (!videoDuration) videoDuration = duration;
    if (videoDuration > maxDuration) {
      setIsLiveContent(true);
      videoDuration = maxDuration;
    }
    setDuration(videoDuration);

    // Accumulate "watched seconds" only for normal playback (ignore large jumps/seeks and ads)
    const prev = lastReportedTimeRef.current || current;
    const delta = current - prev;
    const isPaused = isAd ? adVideoRef.current?.paused : videoRef.current?.paused;

    if (!isAd && !isAdPlayingActive && !isPaused && delta > 0 && delta <= WATCH_JUMP_THRESHOLD) {
      watchedSecondsRef.current += delta;
    }

    // Always update last reported time to prevent double-counting across jumps
    lastReportedTimeRef.current = current;

    // Continue-watching pooling
    if (window.CWPOOLING && (!isLive && !isLiveContent && !(itemData.still_live && itemData.type==0))) {
      const timeSinceLastSave = Math.abs(current - lastContinueWatchingTime.current);
      if (timeSinceLastSave >= window.CWPOOLING) {
        AddToContinueWatching(0); // 0 = is_deleted
        lastContinueWatchingTime.current = current; // Update the ref
      }
    }

    // Ad trigger
    if (!isAd && adConfig && adConfig.client && adConfig.adTimes.includes(Math.floor(current)) && !isAdPlaying) {
      fetchVastAd(adConfig.vastXmlUrl);
    }
  };

  // Simple wrapper used by native timeupdate handlers
  const handleTimeUpdate = () => {
    if (!videoRef.current) return;
    updatePlaybackProgress(videoRef.current.currentTime, { isAd: false });
  }; 

  const destroyPlayer = async () => {
    console.log("Destroying player...");
    
    // 1. Destroy Shaka Player
    if (playerRef.current) {
        playerRef.current.destroy().catch(() => {}); 
        playerRef.current = null;
    }

    // 2. FORCE STOP VIDEO ELEMENT
    // Even if the Ref is null, we try to use the closure variable if available, 
    // or rely on vdoElementRef
    const vEl = videoRef.current || vdoElementRef.current;
    if (vEl) {
        vEl.pause();
        vEl.removeAttribute('src'); 
        vEl.load(); // Vital: Resets the media pipeline
    }
    
    // 3. Stop Ads
    if (adVideoRef.current) {
        adVideoRef.current.pause();
        adVideoRef.current.removeAttribute('src');
        adVideoRef.current.load();
    }

    // 4. Clear Intervals
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (playbackTimeoutRef.current) clearTimeout(playbackTimeoutRef.current);
};

// Use this inside useEffect return and handleBack
useEffect(() => {
   isComponentMounted.current = true;
    return () => {
      isComponentMounted.current = false;
        destroyPlayer();
         if (playerRef.current) {
      try {
        playerRef.current.destroy();
      } catch (e) {}
      playerRef.current = null;
    }
        window.removeEventListener("keydown", handleKeyDown);
    }
}, []);


  const handleSubtitleChange = (subtitle) => {
    console.log("first", subtitle);
    subtitleTextRef.current = subtitle;
    setSubtitle(subtitle);
    setLanguageSettings(false);
  };

  const handleLoadedMetadata = () => {
    if (!videoRef.current) return;
    const maxDuration = 24 * 60 * 60; // 24 hours in seconds
    let videoDuration = videoRef.current.duration;
    if (videoDuration > maxDuration) {
      setIsLiveContent(true);
      videoDuration = maxDuration;
    }
    setDuration(videoDuration);
  };

  // const handleEnded = () => {
  //   console.log("hello end")
  //   // if (isAdPlaying) {
  //   //   setIsAdPlaying(false);
  //   //   adVideoRef.current.style.display = "none";
  //   //   videoRef.current.style.display = "block";
  //   //   videoRef.current.currentTime = currentTimeRef.current;
  //   //   videoRef.current.play();
  //   //   onAdEnd && onAdEnd();
  //   // } else {
  //   //   setIsPlaying(false);
  //   //   if (!hasNextContent) {
  //   //     console.log('RETURNING BACK TO PREVIOUS');
  //   //     onBack && onBack();
  //   //   }
  //   //   else {
  //   //     console.log('PLAYING NEXT EPISODE', nextAvailableContent);
  //   //     onSelect(nextAvailableContent);
  //   //     videoRef.current.play();
  //   //   }
  //   // }
  // };

  const handleEnded = () => {
    console.log(
      "handleNext...",
      nextAvailableContent,
      "itemDetails[0]",
      itemDetails[0]?.season[0]?.videos?.length,
      currentIndex
    );
    isDeletedRef.current = 1;
    AddToContinueWatching(1);
    if (itemDetails[0]?.skip_season == 0) {
      if (
        currentIndex === itemDetails[0]?.season[0]?.videos?.length - 1 ||
        nextAvailableContent == null
      ) {
        onBack && onBack();
      } else {
        handleNextAudio();
      }
    } else {
      isDeletedRef.current = 1;
      AddToContinueWatching(1);
      onBack && onBack();
    }
  };

  const convertTimeStringToSeconds = (timeString) => {
    const parts = timeString.split(":").map(Number);
    return parts[0] * 3600 + parts[1] * 60 + parts[2]; // Convert HH:MM:SS to total seconds
  };

  const handleSkipAd = () => {
    console.log("SkipAdTime", SkipAdTime);
    if (vdoElementRef.current && vdoElementRef.current.currentTime != null) {
      vdoElementRef.current.currentTime = vdoElementRef.current.currentTime + duration_ad;

      // Prevent the next timeupdate from treating this jump as watched playback
      lastReportedTimeRef.current = vdoElementRef.current.currentTime;

      onForward && onForward();
    }
    setFocusedButton("playPause");
  };

 

 

  const handlePlayPause = async () => {
    if (!vdoElementRef.current) return;

    if (isPlaying) {
      vdoElementRef.current.pause();
      setIsPlaying(false);
      onPause && onPause();
       motamoPlayPauseEvent({
      eventActionStatus: "Pause",
      itemDetails,
      itemData,
      CurrentItemData,
      videoRef,
      currentTime,
      sourceContext,
      });

      // console.log("itemDataaaa", itemData, itemDetails, CurrentItemData);
    } else {
      vdoElementRef.current.play();
      setIsPlaying(true);
      onPlay && onPlay();
       motamoPlayPauseEvent ({
      eventActionStatus: "Resume",
      itemDetails,
      itemData,
      CurrentItemData,
      videoRef,
      currentTime,
      sourceContext,
      });;
    }
  };

  const fetchVastAd = (vastXmlUrl) => {
    fetch(vastXmlUrl)
      .then((response) => response.text())
      .then((vastXml) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(vastXml, "text/xml");
        console.log("xmlDoc.....", xmlDoc);
        const mediaFileUrl =
          xmlDoc.getElementsByTagName("MediaFile")[0].textContent || "";
        playAd(mediaFileUrl);
      })
      .catch((error) => console.error(""));
  };

  const playAd = (adUrl) => {
    setIsAdPlaying(true);
    videoRef.current.pause();
    adVideoRef.current.src = adUrl;
    adVideoRef.current.currentTime = 0;
    adVideoRef.current.style.display = "block";
    videoRef.current.style.display = "none";
    adVideoRef.current.play().catch((error) => console.error());
    onAdStart && onAdStart();
  };

  const handleBitrateChange = (bitrate) => {
    if (vdoElementRef.current) vdoElementRef.current.playbackRate = parseFloat(bitrate.replace("x", ""));
    setShowSettings(false);
    // After selecting a bitrate/speed, move UI focus to play/pause
    try {
      setFocusedButton("playPause");
    } catch (e) {}
  };

  const handleKeyDown = async (e) => {
    if (showPlayerErrorUI) {
      window.removeEventListener("keydown", handleKeyDown);
      if (
        e.keyCode === 8 ||
        e.keyCode === 10009 ||
        e.keyCode === 461 ||
        e.keyCode === 13
      ) {
        console.log("handleBack...");
        // window.removeEventListener("keydown", handleKeyDown);
        handleBack();
        setShowPlayerErrorUI(false);
        return;
      }
      return;
    }

    if (showSettings || showLanguage) {
      if (e.keyCode === 8 || e.keyCode === 10009 || e.keyCode === 461) {
        setShowSettings(false);
        setLanguageSettings(false);
        setIsPlaying(true);
        setControlsVisible(true);
        let tmp = setTimeout(() => {
          clearTimeout(tmp);
          setControlsVisible(false);
        }, 5000);
      }
      return;
    }
    if (!controlsVisible && e.keyCode === 13) {
      handlePlayPause();
    }
    if (
      ((!controlsVisible && e.keyCode === 37) ||
        (controlsVisible && e.keyCode === 37)) &&
      focusedButton === "playPause"
    ) {
      handleRewind();
      return; // prevent duplicate handling below in switch-case
    }
    if (
      ((!controlsVisible && e.keyCode === 39) ||
        (controlsVisible && e.keyCode === 39)) &&
      focusedButton === "playPause"
    ) {
      handleForward();
      return; // prevent duplicate handling below in switch-case
    }
    // if (!controlsVisible) {
    //   shouldLoad(false);
    //   setControlsVisible(true);
    //   // setControlsVisible(false);
    //   setFocusedButton(focusedButton);
    //   setLastUserActivity(Date.now());
    //   let tmr = setTimeout(() => {
    //     //if (Date.now() - lastUserActivity > 10000) {
    //     clearTimeout(tmr);
    //     setControlsVisible(false);
    //     //}
    //   }, 5000);
    //   return;
    // }
    switch (e.keyCode) {
      case 37: // Left arrow
        // Ensure controls are visible immediately on key press
        if (!controlsVisible) keepControlsVisible();

        if (focusedButton === "videoLanguage") {
          setFocusedButton("videoSetting");
        } else if (focusedButton === "seekBar") {
          handleRewind();
        } else if (
          focusedButton !== "seekBar" &&
          focusedButton !== "videoSetting" &&
          focusedButton !== "videoLanguage" &&
          focusedButton !== "NextEpisode"
          // && !controlsVisible  <-- Remove this condition if present
        ) {
          handleRewind();
        } else if (focusedButton === "NextEpisode") {
          setFocusedButton("videoLanguage");
        }
        break;

      case 39: // Right arrow
        // Ensure controls are visible immediately on key press
        if (!controlsVisible) keepControlsVisible();

        if (focusedButton === "videoSetting") {
          setFocusedButton("videoLanguage");
        } else if (focusedButton === "seekBar") {
          handleForward();
        } else if (
          focusedButton !== "seekBar" &&
          focusedButton !== "videoSetting" &&
          focusedButton !== "videoLanguage" &&
          focusedButton !== "NextEpisode"
          // && !controlsVisible <-- Remove this condition if present
        ) {
          handleForward();
        } else if (focusedButton === "videoLanguage" && !Isnext && !isLive) {
          setFocusedButton("NextEpisode");
        }
        break;
      case 13: // Enter
        if (hasPlayerLoadTimedOut) {
          // handleBack function is not working because vdoElement is null
          handleBack();
        } else if (SkipAD && focusedButton === "skipAd") {
          handleSkipAd();
          setFocusedButton("playPause");
        } else {
          if (focusedButton === "playPause") {
            handlePlayPause();
          } else if (focusedButton === "backward") {
            handleRewind();
          } else if (focusedButton === "forward") {
            handleForward();
          } else if (focusedButton === "videoSetting") {
            handleSettingsClick();
          } else if (focusedButton === "videoLanguage") {
            handleLanguageClick();
          } else if (focusedButton === "backButton") {
            handleBack();
          } else if (focusedButton === "NextEpisode") {
            handleNextAudio(true);
            await motamoPlayPauseEvent({
            eventActionStatus: "Stop",
            itemDetails,
            itemData,
            CurrentItemData,
            videoRef,
            currentTime,
            sourceContext,
      });
          }
        }
        break;
      case 8: // Back key
      case 461:
      case 10009:
        // if (loading) {
        //   return;
        // }
        // else{
        //   handleBack();
        // }
        handleBack();
        break;
      case 38: // Up arrow
        if (!controlsVisible) {
          shouldLoad(false);
          setControlsVisible(true);
          // setControlsVisible(false);
          setFocusedButton(focusedButton);
          setLastUserActivity(Date.now());
          let tmr = setTimeout(() => {
            //if (Date.now() - lastUserActivity > 10000) {
            clearTimeout(tmr);
            setControlsVisible(false);
            //}
          }, 5000);
          return;
        }
        // if(!controlsVisible) setControlsVisible(true);
        if (
          focusedButton === "videoSetting" ||
          focusedButton === "videoLanguage" ||
          focusedButton === "NextEpisode"
        ) {
          if (!isLiveContent) setFocusedButton("seekBar");
          else if (isLiveContent) setFocusedButton("playPause");
          // setFocusedButton("seekBar");
        }

        if (focusedButton === "seekBar") {
          setFocusedButton("playPause");
        }

        // if (focusedButton === "playPause") {
        //   setFocusedButton("backButton");
        // }

        // if (
        //   focusedButton === "playPause" ||
        //   focusedButton === "forward" ||
        //   focusedButton === "backward"
        // ) {
        //   setFocusedButton("backButton");
        // }

        if (focusedButton === "skipAd" && isAdPlayingActive) {
          console.log("SkipAdTime", SkipAdTime);

          if (SkipAD) {
            setFocusedButton("playPause");
          } else {
            setFocusedButton("skipAd");
          }
        }

        break;
      case 40: // Down arrow
        if (isAdPlayingActive && focusedButton === "playPause") return;
        if (!controlsVisible) {
          shouldLoad(false);
          setControlsVisible(true);
          // setControlsVisible(false);
          setFocusedButton(focusedButton);
          setLastUserActivity(Date.now());
          let tmr = setTimeout(() => {
            //if (Date.now() - lastUserActivity > 10000) {
            clearTimeout(tmr);
            setControlsVisible(false);
            //}
          }, 5000);
          return;
        }
        // if(!controlsVisible) setControlsVisible(true);
        // if (
        //   (focusedButton === "playPause" ||
        //     focusedButton === "forward" ||
        //     focusedButton === "backward") && !isAdPlayingActive
        // ) {
        //   if(!isLiveContent) setFocusedButton("seekBar");
        //   else if (isLiveContent) setFocusedButton("videoSetting");
        // }
        if (focusedButton === "playPause" && !isAdPlayingActive) {
          if (!isLiveContent) setFocusedButton("seekBar");
          else if (isLiveContent) setFocusedButton("videoSetting");
        } else if (focusedButton === "playPause" && isAdPlayingActive) {
          console.log("SkipAdTime", SkipAdTime);
          if (SkipAD) {
            setFocusedButton("skipAd");
          } else {
            setFocusedButton("seekBar");
          }
        }

        if (focusedButton === "seekBar") {
          setFocusedButton("videoSetting");
        }

        break;

        // if (focusedButton === "backButton") {
        //   setFocusedButton("playPause");
          // if(isLiveContent){
          //   setFocusedButton("playPause");
          // }
          // else{
          //   setFocusedButton("backward");
          // }
        // }
      case 427: // ch+
        handleNextLive();
        break;

      case 428: // ch-
        handlePreLive();
        break;
      case 415:
      case 19:
      case 463:
        handlePlayPause();
        break;
      case 417:
        handleForward();
        break;
      case 412:
        handleRewind();
        break;
      case 10252: //Media playpause
        console.log("case media playpause...");
        handlePlayPause();
      default:
        console.log("default keycode...", e.keyCode);
        break;
    }
  };

  const handleNextLive = async () => {
  const similarList = itemData?.similar;

  // ✅ Guard checks
  if (!Array.isArray(similarList)) {
    console.warn("similar list missing or invalid", similarList);
    return;
  }

  const nextIndex = currentIndexLive + 1;

  if (nextIndex >= similarList.length) {
    return;
  }

  setcurrentIndexLive(nextIndex);

  const nextVideoId = similarList[nextIndex];
  if (!nextVideoId) return;

  console.log("nextVideoId", nextVideoId);

  setCurrentItemData(nextVideoId);
  initVideo(nextVideoId);
};


  // const handleNextLive = async () => {
  //   if (currentIndexLive + 1 >= itemData?.similar?.length) {
  //     return;
  //   }
  //   const nextIndex = currentIndexLive + 1;
  //   setcurrentIndexLive(nextIndex);

  //   const nextVideoId = itemData?.similar[nextIndex];
  //   console.log("nextVideoId", nextVideoId);
  //   setCurrentItemData(nextVideoId);
  //   initVideo(nextVideoId);
  // };

  const handlePreLive = async () => {
    console.log("currentIndexLive", currentIndexLive);
    if (currentIndexLive == 0) {
      console.log("No previous tracks available.");
      return;
    }
    setcurrentIndexLive(currentIndexLive - 1);
    const videoId = itemData.similar[currentIndexLive - 1];
    console.log("videoId", videoId);
    setCurrentItemData(videoId);
    setCurrentDrmInfo(videoId);
    initVideo(videoId);
  };

  // const handleRewind = () => {
  //   if (vdoElement.currentTime !== null) {
  //     vdoElement.currentTime = vdoElement.currentTime - 10;
  // const handleRewind = async () => {
  //   if (isAdPlayingActive || isLiveContent) return false;
  //   if (vdoElement?.currentTime !== null) {
  //     vdoElement.currentTime = vdoElement.currentTime - 10;
  //     let seekPercentage = (vdoElement.currentTime / duration) * 70;

  //     if (focusedButton === "seekBar") {
  //       updateTrickplayImage(
  //         preloadedImagesdata,
  //         seekPercentage,
  //         vdoElement.currentTime
  //       );
  //     }
  //     // updateTrickplayImage(preloadedImagesdata, seekPercentage, vdoElement.currentTime);
  //     onRewind && onRewind();
  //     handleMotamoRewindEvent();

  //     // Sending impression and interaction events
  //   }
  // };

  // const handleRewind = async () => {
  //   if (isAdPlayingActive || isLiveContent) return false;
  //   if (vdoElement?.currentTime !== null) {
  //     vdoElement.currentTime = vdoElement.currentTime - 10;

  //     // Trickplay logic commented out/disabled
  //     /*
  //     let seekPercentage = (vdoElement.currentTime / duration) * 70;
  //     if (focusedButton === "seekBar") {
  //       updateTrickplayImage(
  //         preloadedImagesdata,
  //         seekPercentage,
  //         vdoElement.currentTime
  //       );
  //     }
  //     */

  //     onRewind && onRewind();
  //     // handleMotamoRewindEvent();
  //   }
  // };

  // const handleRewind = async () => {
  //   // 1. Add this line to keep bar visible
  //   keepControlsVisible();

  //   if (isAdPlayingActive || isLiveContent) return false;
  //   if (vdoElement?.currentTime !== null) {
  //     vdoElement.currentTime = Math.max(0, vdoElement.currentTime - 10);
  //     const newTime = vdoElement.currentTime;
  //     try {
  //       setCurrentTime(newTime);
  //       setCurrentTimeSeek(newTime);
  //     } catch (e) {}

  //     onRewind && onRewind();
  //     // handleMotamoRewindEvent();
  //   }
  // };

  const handleRewind = async () => {
    console.log("handleRewind called...");
    keepControlsVisible();

    if (isAdPlayingActive || isLiveContent) return false;

    onRewind && onRewind();
    // 1. Clear pending commit
    if (seekTimeoutRef.current) {
      clearTimeout(seekTimeoutRef.current);
    }

    // 2. Determine base time
    const baseTime = seekInProgress ? currentTimeSeek : currentTime;

    // 3. Calculate new time (limit to 0)
    let newTime = baseTime - 10;
    if (newTime < 0) newTime = 0;

    // 4. Update UI State immediately
    if (!seekInProgress){
      setSeekInProgress(true);
      accumulatedSeekRef.current = 0;
    } 
    accumulatedSeekRef.current -= 10;
    setCurrentTimeSeek(newTime);

    // 5. Set timeout to commit
    seekTimeoutRef.current = setTimeout(() => {
      commitSeek(newTime);
    }, 400);



  };

  



  // const handleForward = async () => {
  //   if (isAdPlayingActive || isLiveContent) return false;
  //   console.log("handleForward", vdoElement);
  //   if (vdoElement?.currentTime !== null) {
  //     vdoElement.currentTime = vdoElement.currentTime + 10;
  //     let seekPercentage = (vdoElement.currentTime / duration) * 70;

  //     if (focusedButton === "seekBar") {
  //       updateTrickplayImage(
  //         preloadedImagesdata,
  //         seekPercentage,
  //         vdoElement.currentTime
  //       );
  //     }
  //     // updateTrickplayImage(preloadedImagesdata, seekPercentage, vdoElement.currentTime);
  //     onForward && onForward();
  //     handleMotamoForwardEvent();

  //     // Sending impression and interaction events

  //   }
  // };

  // const handleForward = async () => {
  //   if (isAdPlayingActive || isLiveContent) return false;
  //   console.log("handleForward", vdoElement);
  //   if (vdoElement?.currentTime !== null) {
  //     vdoElement.currentTime = vdoElement.currentTime + 10;

  //     // Trickplay logic commented out/disabled
  //     /*
  //     let seekPercentage = (vdoElement.currentTime / duration) * 70;
  //     if (focusedButton === "seekBar") {
  //       updateTrickplayImage(
  //         preloadedImagesdata,
  //         seekPercentage,
  //         vdoElement.currentTime
  //       );
  //     }
  //     */

  //     onForward && onForward();
  //     // handleMotamoForwardEvent();
  //   }
  // };

  // const handleForward = async () => {
  //   // 1. Add this line to keep bar visible
  //   keepControlsVisible();

  //   if (isAdPlayingActive || isLiveContent) return false;
  //   console.log("handleForward", vdoElement);
  //   if (vdoElement?.currentTime !== null) {
  //     vdoElement.currentTime = Math.min(duration || Infinity, vdoElement.currentTime + 10);
  //     const newTime = vdoElement.currentTime;
  //     try {
  //       setCurrentTime(newTime);
  //       setCurrentTimeSeek(newTime);
  //     } catch (e) {}

  //     onForward && onForward();
  //     // handleMotamoForwardEvent();
  //   }
  // };

 const handleForward = async () => {
    console.log("handleForward called...");
    keepControlsVisible();

    if (isAdPlayingActive || isLiveContent) return false;

    onForward && onForward();
    // 1. Clear any pending seek commit so we don't jump while the user is still holding the key
    if (seekTimeoutRef.current) {
      clearTimeout(seekTimeoutRef.current);
    }

    // 2. Determine the base time.
    // If we are already seeking, add to the temporary time.
    // If not, start from the current video time.
    const baseTime = seekInProgress ? currentTimeSeek : currentTime;

    // 3. Calculate new time (limit to duration)
    let newTime = baseTime + 10;
    if (newTime > duration) newTime = duration;

    // 4. Update UI State immediately (Visual Only)
    if (!seekInProgress) {
      setSeekInProgress(true);
      accumulatedSeekRef.current = 0; 
    }

    accumulatedSeekRef.current += 10;
    setCurrentTimeSeek(newTime);

    // 5. Set a timeout to commit the seek after the user stops pressing keys (e.g., 400ms)
    seekTimeoutRef.current = setTimeout(() => {
      commitSeek(newTime);
    }, 400);

  
  };
  // function updateTrickplayImage(preloadedImages, seekPercentage, currentTime) {
  //   // console.log("preloadedImages", preloadedImages);
  //   if (preloadedImages === undefined || preloadedImages === null) return;
  //   if (Object.keys(preloadedImages).length === 0) return;
  //   let keys = Object.keys(preloadedImages).map(Number);
  //   let closestKey = keys?.reduce((prev, curr) =>
  //     Math.abs(curr - currentTime) < Math.abs(prev - currentTime) ? curr : prev
  //   );

  //   let trickplayImage = preloadedImages[closestKey]?.src;
  //   // console.log("trickplayImage 900", trickplayImage);
  //   if (!trickplayImage) return;

  //   // Assuming 5 columns and each thumbnail is 480x272
  //   const thumbWidth = 480;
  //   const thumbHeight = 272;
  //   const columns = 5;

  //   const index = closestKey;
  //   const col = index % columns;
  //   const row = Math.floor(index / columns);

  //   const backgroundX = -(col * thumbWidth);
  //   const backgroundY = -(row * thumbHeight);

  //   requestAnimationFrame(() => {
  //     let trickplayImageElement = document.getElementById("trickplay-image");
  //     let trickplayContainer = document.getElementById("trickplay-container");
  //     let player = document.getElementById("video-player-shaka");

  //     if (trickplayImageElement && player && trickplayContainer) {
  //       // set background instead of src
  //       trickplayImageElement.style.backgroundImage = `url('${trickplayImage}')`;
  //       // trickplayImageElement.style.backgroundPosition = `${backgroundX}px ${backgroundY}px`;
  //       trickplayImageElement.style.display = "block";

  //       let playerWidth = player.offsetWidth;
  //       let imageWidth = thumbWidth;

  //       let imagePosition = (seekPercentage / 100) * playerWidth;
  //       imagePosition = Math.max(
  //         10,
  //         Math.min(imagePosition, playerWidth - imageWidth)
  //       );

  //       trickplayContainer.style.left = `${imagePosition}px`;
  //     }
  //   });
  // }

  // function calculate_trickplay(trickplay_obj, media_duration) {
  //   let image_url = trickplay_obj.url;
  //   let rows = trickplay_obj.rows;
  //   let columns = trickplay_obj.columns;
  //   let height = trickplay_obj.height;
  //   let width = trickplay_obj.width;
  //   let intervel = trickplay_obj["thumbnail-interval"];

  //   let pictures_per_frame = Math.round((rows * columns) / intervel);
  //   let total_frames = Math.round(media_duration / pictures_per_frame);
  //   for (let index = 1; index <= total_frames; index++) {
  //     let formattedIndex = String(index);
  //     while (formattedIndex.length < 9) {
  //       formattedIndex = "0" + formattedIndex;
  //     }
  //     trickPlayArray[index * pictures_per_frame] =
  //       image_url + "Thumbnail_" + formattedIndex + ".jpg";
  //   }

  //   for (let key in trickPlayArray) {
  //     let image = new Image();
  //     image.src = trickPlayArray[key];
  //     preloadedImages[key] = image;
  //     setpreloadedImagesdata(preloadedImages);
  //     // console.log("preloadedImages[key]", preloadedImages);
  //   }

  //   // console.log("trickPlayArray", trickPlayArray);
  //   return trickPlayArray;
  // }

  const handleSeek = async (event) => {
    if (isAdPlayingActive) return false;
    const seekTime =
      (event.nativeEvent.offsetX / event.target.clientWidth) * duration;
    if (vdoElementRef.current) vdoElementRef.current.currentTime = seekTime;

    // Prevent the next timeupdate from treating this jump as watched playback
    lastReportedTimeRef.current = seekTime;

   // Sending impression and interaction events
handleVideoNavigationEvent({
  type: "seek",
  newTime: parseInt(seekTime),
  itemDetails,
  itemData,
  CurrentItemData,
  currentTime,
});
  }; 

  // const handleSeek = async (event) => {
  //   // Logic disabled to prevent seeking via mouse click/hover
  //   return;

  //   /* Original logic commented out
  //   if (isAdPlayingActive) return false;
  //   const seekTime =
  //     (event.nativeEvent.offsetX / event.target.clientWidth) * duration;
  //   vdoElement.currentTime = seekTime;

  //   // Sending impression and interaction events
  //   // handleSeekBarEvent(formatSecondsToHMS(parseInt(seekTime)));
  //   */
  // };

  // Add this inside VideoPlayer component
  const keepControlsVisible = () => {
    setControlsVisible(true);
    setLastUserActivity(Date.now());

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setControlsVisible(false);
    }, 5000); // 5 seconds wait before hiding
  };

  //  const handleBack = async () => {
  //     if (intervalId) clearInterval(intervalId);

  //     window.videoLanguage = false;
  //     window.isStartOverSelectedButton = false;

  //     try {
  //       if (vdoElement) {
  //         // ✅ If Shaka Player is attached
  //         if (typeof vdoElement.destroy === "function") {
  //           videoElement?.destroy();  // destroys Shaka player
  //           vdoElement = null; // finally set to null
  //           vdoElement?.destroy();
  //           setType(false);
  //           setIsPlaying(false);

  //           onPause && onPause();
  //           videoElement?.pause();
  //           vdoElement?.pause();
  //           vdoElement?.removeAttribute("src");
  //           onBack && onBack();
  //           console.log("Shaka player destroyed");
  //         } else if (vdoElement.pause) {
  //           // ✅ If it's just a video element
  //           videoElement?.destroy();
  //           vdoElement = null; // finally set to null
  //           vdoElement?.destroy();
  //           setType(false);
  //           setIsPlaying(false);

  //           onPause && onPause();
  //           videoElement?.pause();
  //           vdoElement?.pause();
  //           onBack && onBack();
  //           vdoElement?.removeAttribute("src");
  //           vdoElement.load();  // ensures video buffer is cleared
  //           console.log("Video element paused & cleared");
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Error while destroying player:", err);
  //     }

  //     vdoElement = null; // finally set to null
  //     vdoElement?.destroy();
  //     setType(false);
  //     setIsPlaying(false);

  //     onPause && onPause();
  //     videoElement?.pause();
  //     vdoElement?.pause();
  //     vdoElement?.removeAttribute("src");
  //     onBack && onBack();

  //     if (!isLive || !isLiveContent || itemDetails[0]?.still_live === 1) {
  //       AddToContinueWatching(is_deleted);
  //     }
  //     motamoPlayPlauseEvent("Stop");

  //       if (window.GETCONTINUEDATA && window.GETCONTINUEDATA[0]?.data) {
  //   const existingIndex = window.GETCONTINUEDATA[0].data.findIndex(
  //     (item) =>
  //       item.duration &&
  //       Array.isArray(item.duration) &&
  //       item.duration[0]?.id === itemData.id
  //   );

  //   if (existingIndex !== -1) {
  //     window.GETCONTINUEDATA[0].data[existingIndex].duration[0].paused_at = currentTime;
  //   } else {
  //     window.GETCONTINUEDATA[0].data.push(
  //       { show_id: itemData.id },
  //       {
  //         duration: [
  //           {
  //             id: itemData.id,
  //             paused_at: currentTime,
  //           },
  //         ],
  //       }
  //     );
  //   }
  // };
  //   };

  const handleBack = async (e) => {
    console.log("handleQualityControl..111111111...");
 

    window.videoLanguage = false;

    if (hasPlayerLoadTimedOut) {
      //window.location.reload();
      //show Go back button
    }
    window.isStartOverSelectedButton = false;
    // if(!handleQualityControl)return

    if (vdoElementRef.current) {
      try {
        vdoElementRef.current.pause?.();
      } catch (e) {}
      try {
        vdoElementRef.current.src = "";
      } catch (e) {}
      // clear local DOM ref
      videoRef.current = null;
      setType(false);
    }
    if (vdoElementRef.current && typeof vdoElementRef.current.destroy === "function") {
      try {
        vdoElementRef.current.destroy();
      } catch (e) {}
    }
    vdoElementRef.current = null;
    onPause && onPause();
    onBack && onBack();
 
    if (!isLive || !isLiveContent||!(itemData.still_live && itemData.type==0)) {
    AddToContinueWatching(isDeletedRef.current ?? 0);
    }

       if (
      itemDetails?.[0]?.category_title === "TV Channels" ||
      itemDetails?.[0]?.category_title === "Live"
    ) {
      sendLiveChannelEvent({
        actionType: "Stop",
        itemData,
        itemDetails,
      });
    } else {
      await motamoPlayPauseEvent({
      eventActionStatus: "Stop",
      itemDetails,
      itemData,
      CurrentItemData,
      videoRef,
      currentTime,
      sourceContext,
      });
    }
  };
  const handleError = (e) => {
    onError && onError(e);
  };

  useEffect(() => {
    const videoElement1 = videoRef.current;
    const videoElement2 = adVideoRef.current;

    if (videoElement1) {
      const updateTime = () => {
        if (videoRef.current) {
          const currentVal = videoElement1.currentTime;
          updatePlaybackProgress(currentVal, { isAd: false });
        }
      };  

      videoElement1.addEventListener("timeupdate", updateTime);
      return () => {
        videoElement1.removeEventListener("timeupdate", updateTime);
      };
    } else if (videoElement2) {
      const updateTime2 = () => {
        if (adVideoRef.current) {
          updatePlaybackProgress(videoElement2.currentTime, { isAd: true });
        }
      };

      videoElement2.addEventListener("timeupdate", updateTime2);
      return () => {
        videoElement2.removeEventListener("timeupdate", updateTime2);
      };
    }
  }, []);

  // useEffect(() => {
  //   // Convert CWPOOLING to milliseconds
  //   const intervalTime = window.CWPOOLING * 1000;

  //   // Start interval
  //   // intervalRef.current = setInterval(() => {
  //   //   AddToContinueWatching((is_deleted = 0));
  //   // }, intervalTime);
  //   if (!isLive || !isLiveContent) {
  //     if (window.CWPOOLING !== undefined) {
  //       intervalRef.current = setInterval(() => {
  //         AddToContinueWatching((is_deleted = 0));
  //       }, intervalTime);
  //     }
  //   }

  //   // Cleanup when component unmounts
  //   return () => {
  //     clearInterval(intervalRef.current);
  //   };
  // }, []);

  const handleMetadataLoaded = () => {
    if (videoRef.current) {
      // Get the video duration and format it
      const duration = videoRef.current.duration;
      const formattedDuration = formatTime(duration);
      console.log(formattedDuration, "checkingDuration");

      // Update the totalTime state with the formatted duration
      setTotalTime(formattedDuration);
    } else if (adVideoRef.current) {
      // Get the video duration and format it
      const duration = adVideoRef.current.duration;
      const formattedDuration = formatTime(duration);

      // Update the totalTime state with the formatted duration
      setTotalTime(formattedDuration);
    }
  };

  const formatTime = (time) => {
    if (isNaN(time) || time < 0) {
      return "00:00:00"; // Default format when time is not available
    }
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    return `${hours < 10 ? "0" : ""}${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const formatMinutesSeconds = (time) => {
    if (isNaN(time) || time < 0) {
      return "00:00"; // Default format when time is invalid
    }

    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);

    return `${minutes < 10 ? "0" : ""}${minutes}:${
      seconds < 10 ? "0" : ""
    }${seconds}`;
  };

  const handleSettingsClick = () => {
    console.log(language);
    window.videoSettings = true;
    setControlsVisible(true);
    if (showLanguage) {
      setLanguageSettings(false);
    }
    setShowSettings((prevSettings) => (prevSettings = !prevSettings)); // Switch to the settings page when the button is clicked
    window.removeEventListener("keydown", handleKeyDown);
    // videoRef.current.play();
    // videoRef.current.pause();
    // setIsPlaying(true);
  };

  const handleLanguageClick = () => {
    console.log();
    window.videoLanguage = true;
    setControlsVisible(true);

    if (showSettings) {
      setShowSettings(false);
    }
    setLanguageSettings((prevSettings) => (prevSettings = !prevSettings)); // Switch to the settings page when the button is clicked
    window.removeEventListener("keydown", handleKeyDown);
    // videoRef.current.pause();
    // setIsPlaying(true);
  };
  const handleEpisodeChange = () => {
    // Show loader immediately
    showLoader(true);

    // Wait 1 second before loading the next episode
    setTimeout(() => {
      // Hide the loader
      showLoader(false);
      // Call the function that loads the next episode
      handleNextAudio();
    }, 1500);
  };

  const checkMediaType = () => {
    // const tracks = player.getVariantTracks();

    // List available text tracks (subtitles)
    const tracks = player.getTextTracks();

    let hasVideo = false;
    let hasAudio = false;

    tracks.forEach((track) => {
      console.log("Track3333:", track);
      if (track.videoCodec) {
        hasVideo = true;
      }
      if (track.audioCodec) {
        hasAudio = true;
      }
    });

    // const tracks = player.getTextTracks();
    const hindiTrack = tracks.find((track) => track.language === "hi"); // Language code for Hindi
    // Disable ABR to prevent it from overriding manual track selection
    // newPlayer.configure({ abr: { enabled: false } });

    // Select the desired subtitle track
    // player.selectTextTrack(hindiTrack);

    // Ensure subtitles are visible
    if (hindiTrack) {
      // player.selectTextTrack(hindiTrack);
    } else {
      console.error("Hindi subtitle track not found.");
    }

    // Re-enable ABR (if required)
    //  player.configure({ abr: { enabled: true } });

    if (hasVideo && hasAudio) {
    } else if (hasAudio && !hasVideo) {
      setType(true);
    } else if (hasVideo && !hasAudio) {
    } else {
    }
  };

  // Mouse Controls
  useEffect(() => {
    const handleMouseMove = () => {
      setControlsVisible(true);
      setLastUserActivity(Date.now());

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        if (Date.now() - lastUserActivity > 5000) {
          setControlsVisible(false);
        }
      }, 5000);
    };

    const handleClick = (event) => {
      const videoPlayerTarget = document.getElementById("video-player-shaka");
      const adPlayerTarget = document.getElementById("ads-player-shaka");

      if (
        (showSettings || showLanguage) &&
        (event.target === videoPlayerTarget || event.target === adPlayerTarget)
      ) {
        setShowSettings(false);
        setLanguageSettings(false);
      }
    };

    if (!forceDisableControls) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("click", handleClick);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("click", handleClick);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [lastUserActivity]);

  const handleLanguageChange = (language) => {
    console.log("language1111111111111", language);
    // videoRef.current.play();
    console.log(language, "language1");
    languageTextRef.current = language;
    setLanguage(language);
    // setIsPlaying(true);
    setControlsVisible(true);
    setLanguageSettings(false);
  };

const handleSpeedControl = (speed) => {
    console.log("1024...", speed);
    setSelectSpeed(speed);
   
    const newRate = parseFloat(speed);
   
    if (vdoElementRef.current) {
      vdoElementRef.current.playbackRate = newRate;

      const currentTime = vdoElementRef.current.currentTime;

      if (duration && currentTime + 0.1 < duration) {
        vdoElementRef.current.currentTime = currentTime + 0.1;
      } else {
        vdoElementRef.current.currentTime = currentTime;
      }
      if (vdoElementRef.current.paused) {
        vdoElementRef.current.play().catch((e) => console.error("Play error after speed change", e));
      }
    }
 
    setControlsVisible(true);
    setShowSettings(false);
  };

  const mediaPlayBackMotamoEvent = async () => {
    try {
      await matomoPlaybackEvent({
        videoElement: videoRef.current,
        watchedSeconds: Math.floor(watchedSecondsRef.current) || 0,
        mediaId: mediaIdRef.current,
        CurrentItemData,
        itemData,
        itemDetails,
        DrmInformatin,
        GetVideoUrlData,
      });
    } catch (e) {
      console.error("Error sending Matomo playback event", e);
    }
  };

  const handleQualityControl = (quality) => {
 
    switch (quality) {
      case "Auto":
        if (vdoElementRef.current) {
          vdoElementRef.current.style.height = "100%";
          vdoElementRef.current.style.width = "100%";
        }
        // videoRef.current.play();
        // setIsPlaying(true);
        setControlsVisible(true);
        break;
      case "1080p":
        if (vdoElementRef.current) {
          vdoElementRef.current.style.height = "100%";
          vdoElementRef.current.style.width = "100%";
        }
        // videoRef.current.play();
        // setIsPlaying(true);
        setControlsVisible(true);
        break;
      case "720p":
        if (vdoElementRef.current) {
          vdoElementRef.current.style.height = "100%";
          vdoElementRef.current.style.width = "100%";
        }
        // videoRef.current.play();
        // setIsPlaying(true);
        setControlsVisible(true);
        break;
      case "360p":
        if (vdoElementRef.current) {
          vdoElementRef.current.style.height = "100%";
          vdoElementRef.current.style.width = "100%";
        }
        // videoRef.current.play();
        // setIsPlaying(true);
        setControlsVisible(true);
        break;
      case "216p":
        if (vdoElementRef.current) {
          vdoElementRef.current.style.height = "100%";
          vdoElementRef.current.style.width = "100%";
        }
        // videoRef.current.play();
        // setIsPlaying(true);
        setControlsVisible(true);
        break;
      default:
        break;
    }
    setSelectedQuality(quality);
    setShowSettings(false);
    // After selecting quality, move UI focus to play/pause
    try {
      setFocusedButton("playPause");
    } catch (e) {}
  };

  useEffect(() => {
    const interval = setInterval(() => {
      mediaPlayBackMotamoEvent();
    }, 5000);

    return () => clearInterval(interval);
  }, [CurrentItemData, itemDetails, itemData, GetVideoUrlData, DrmInformatin]);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Named handlers so we can remove them on cleanup
    const onPlayHandler = () => {
      showLoader(false);
      setHasPlayerLoadTimedOut(false);
      if (playbackTimeoutRef.current) {
        clearTimeout(playbackTimeoutRef.current);
        playbackTimeoutRef.current = null;
      }
      setIsPlaying(true);
      setShowBgImage(false);
      setControlsVisible(true);
      onPlay && onPlay();

      // Ensure the last reported time is set when playback resumes so we don't accidentally count a jump
      lastReportedTimeRef.current = videoRef.current?.currentTime || lastReportedTimeRef.current;

      handleWaitingState(false);
    }; 

    const onPauseHandler = () => {
      onPause && onPause();
    };

    const onTimeUpdateHandler = handleTimeUpdate;
    const onLoadedMetadataHandler = handleLoadedMetadata;
    const onEndedHandler = handleEnded;
    const onErrorHandler = handleError;

    const onWaitingHandler = () => handleWaitingState(true);
    const onPlayingHandler = () => handleWaitingState(false);
    const onSeekingHandler = () => handleWaitingState(true);
    const onSeekedHandler = () => handleWaitingState(false);

    videoElement.addEventListener("play", onPlayHandler);
    videoElement.addEventListener("pause", onPauseHandler);
    videoElement.addEventListener("timeupdate", onTimeUpdateHandler);
    videoElement.addEventListener("loadedmetadata", onLoadedMetadataHandler);
    videoElement.addEventListener("ended", onEndedHandler);
    videoElement.addEventListener("error", onErrorHandler);
    videoElement.addEventListener("waiting", onWaitingHandler);
    videoElement.addEventListener("playing", onPlayingHandler);
    videoElement.addEventListener("seeking", onSeekingHandler);
    videoElement.addEventListener("seeked", onSeekedHandler);

    window.addEventListener("keydown", handleKeyDown);

    const controlTimeout = setTimeout(() => {
      setControlsVisible(false);
    }, 5000);

    return () => {
      try {
        abortControllerRef.current?.abort();
        abortControllerRef.current = null;
        videoElement.removeEventListener("play", onPlayHandler);
        videoElement.removeEventListener("pause", onPauseHandler);
        videoElement.removeEventListener("timeupdate", onTimeUpdateHandler);
        videoElement.removeEventListener(
          "loadedmetadata",
          onLoadedMetadataHandler
        );
        videoElement.removeEventListener("ended", onEndedHandler);
        videoElement.removeEventListener("error", onErrorHandler);
        videoElement.removeEventListener("waiting", onWaitingHandler);
        videoElement.removeEventListener("playing", onPlayingHandler);
        videoElement.removeEventListener("seeking", onSeekingHandler);
        videoElement.removeEventListener("seeked", onSeekedHandler);
      } catch (e) {
        // element might be already removed from DOM
      }
      window.removeEventListener("keydown", handleKeyDown);
      clearTimeout(controlTimeout);
      if (playbackTimeoutRef.current) {
        clearTimeout(playbackTimeoutRef.current);
        playbackTimeoutRef.current = null;
      }
    };
  }, [
    GetVideoUrlData,
    videoSrc,
    type,
    adConfig,
    lastUserActivity,
    onAdEnd,
    onAdStart,
    onError,
    onPause,
    onPlay,
    onBack,
    controlsVisible,
    shouldloadVideo,
    isPlaying,
    focusedButton,
    showBgImage,
    isAudio,
    showSettings,
    showLanguage,
    videoRef.current,
    isAdPlayingActive,
  ]);

  // Track ad progress in real-time based on elapsed time since ad started
  useEffect(() => {
    if (!isAdPlayingActive || !adStartTimeRef.current) {
      return;
    }

    // If paused, don't update the progress
    if (!isPlaying) {
      return;
    }

    const adProgressInterval = setInterval(() => {
      const elapsedMs = Date.now() - adStartTimeRef.current;
      const elapsedSeconds = elapsedMs / 1000;
      adElapsedTimeRef.current = elapsedSeconds;
      setcurrentTime_ad(Math.max(0, elapsedSeconds));
    }, 100); // Update every 100ms for smooth progress

    return () => clearInterval(adProgressInterval);
  }, [isAdPlayingActive, isPlaying]);

  // Handle pause/resume for ads by adjusting the start time reference
  useEffect(() => {
    if (!isAdPlayingActive || !adStartTimeRef.current) {
      return;
    }

    if (!isPlaying) {
      // Ad is paused - save the elapsed time
      const elapsedMs = Date.now() - adStartTimeRef.current;
      adElapsedTimeRef.current = elapsedMs / 1000;
    } else {
      // Ad is resumed - adjust the start time so elapsed time calculation continues correctly
      adStartTimeRef.current = Date.now() - (adElapsedTimeRef.current * 1000);
    }
  }, [isPlaying, isAdPlayingActive]);

  const methods = {
    handlePlayPause,
    handleRewind,
    handleForward,
    handleSeek,
    handleSettingsClick,
    handleLanguageClick,
    handleEpisodeChange,
    handleSpeedControl,
    handleQualityControl,
    handleBitrateChange,
    handleKeyDown,
    handleLanguageChange,
    handleMetadataLoaded,
    handleEnded,
    handleError,
    formatTime,
    formatMinutesSeconds,
    handleBack,
    handleSubtitleChange,
    handleSkipAd,
  };

  const states = {
    isPlaying,
    showBgImage,
    currentTime,
    focusedButton,
    showSettings,
    showLanguage,
    isAudio,
    adVideoRef,
    videoRef,
    duration,
    loading,
    isAdPlaying,
    controlBarHeight,
    controlsColor,
    controlsVisible,
    isLive,
    progressBarColor,
    availableBitrates,
    adConfig,
    backgroundImage,
    mpdXMLInfo,
    itemData,
    player,
    hasPlayerLoadTimedOut,
    showPlayerErrorUI,
    seekInProgress,
    currentTimeSeek,
    isLiveContent,
    showPlayPauseButtonUi,
    duration_ad,
    currentTime_ad,
    isAdPlayingActive,
    Isnext,
    CurrentItemData,
    SkipAD,
    SkipAdTime,
    selectSpeed,
    selectedQuality,
    subtitle,
    language,
    itemDetails,
  };

  const timeoutRef = useRef(null);

  return <VideoPlayerUI methods={methods} states={states} props={props} />;
};

export default VideoPlayer;
